module.exports = __webpack_public_path__ + "static/media/c-remove.90533e89.svg";